export const device = {
  namespaced: true,
  state: {
    isMobile: false,
    canUseCookies: false,
  },
  mutations: {
    setIsMobile(state, value) {
      state.isMobile = value
    },
    setCanUseCookies(state, value) {
      state.canUseCookies = value
    },
  },
  actions: {
    setIsMobile({ commit }, value) {
      commit('setIsMobile', value)
    },
    setCanUseCookies({ commit }, value) {
      commit('setCanUseCookies', value)
    },
  },
  getters: {
    isMobile: (state) => state.isMobile,
    canUseCookies: (state) => state.canUseCookies,
  },
}
